import React, { Component } from "react";
import { Icon, Card } from "antd";
import { Translate } from "react-translated";
import StatBox from "../../../../components/stat-box";

class Stats extends Component {
  render() {
    let { stats, loading, period, start_date, end_date } = this.props;

    return (
      <div style={{ marginBottom: 20 }}>
        <Card
          title={
            <div>
              <Icon
                type="appstore"
                style={{ marginRight: 10, color: "#1890ff" }}
              />
              <Translate text={`Stats`} />
            </div>
          }
          bordered={false}
          className="statsDetails"
        >
          <div className="statsGrid">
            <Card bordered={false} loading={loading}>
              <StatBox
                title="Follow up schedule appointment"
                val={stats.total_sent_to_efs || 0}
                color={"red"}
                history={this.props.history}
                period={period}
                start_date={start_date}
                end_date={end_date}
                gridStyleWidth="33.33%"
                user_type="AGENCY_MANAGER"
              />
              <StatBox
                title="Not Interested"
                val={stats.not_interested || 0}
                color={"green"}
                history={this.props.history}
                period={period}
                start_date={start_date}
                end_date={end_date}
                gridStyleWidth="33.33%"
                user_type="AGENCY_MANAGER"
              />
              <StatBox
                title="Not Reached"
                val={stats.not_reached || 0}
                color={"blue"}
                history={this.props.history}
                period={period}
                start_date={start_date}
                end_date={end_date}
                gridStyleWidth="33.33%"
                user_type="AGENCY_MANAGER"
              />
              {/* <StatBox
                title="Appointments Made"
                val={stats.appointments_made}
                color={"purple"}
              />
              <StatBox
                title="Appointments Kept"
                val={stats.appointments_kept}
                color={"yellow"}
              />
              <StatBox
                title="Appointments Sold"
                val={stats.appointments_sold}
                color={"blue4"}
              /> */}
            </Card>
          </div>
        </Card>
      </div>
    );
  }
}

export default Stats;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/parts/vonboard/stats.js